import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Switch, Divider, Chip } from "@mui/material";

import FormField from "layouts/ecommerce/products/edit-product/components/FormField";

function FormFields({
  initialData,
  formValues,
  invitationValue,
  ticketsValue,
  initialIsLimitedTickets,
  initialIsLimitedInvitations,
  eventImgList = [],
  selectedEvents = [],
  onSelectedEventsChange,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.only("sm"));

  const [formDataValues, setFormDataValues] = useState({
    typeOfCompany: "1",
    type: "societe",
    isActive: "false",
  });

  const [selectedRadioValue, setSelectedRadioValue] = useState("montant");
  const [limitedTickets, setLimitedTickets] = useState(false);
  const [limitedInvitations, setLimitedInvitations] = useState(false);

  const handleRadioChange = (event) => {
    setSelectedRadioValue(event.target.value);
  };

  useEffect(() => {
    if (initialData) {
      setFormDataValues(initialData);
    } else {
      setFormDataValues({ typeOfCompany: "1" }, { type: "societe" }, { isActive: "false" });
    }
  }, [initialData]);

  useEffect(() => {
    setLimitedTickets(initialIsLimitedTickets);
  }, [initialIsLimitedTickets]);

  useEffect(() => {
    setLimitedInvitations(initialIsLimitedInvitations);
  }, [initialIsLimitedInvitations]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newFormDataValues = {
      ...formDataValues,
      [name]: value,
    };
    if (name === "password" && !value) {
      delete newFormDataValues.password;
    }
    if (name === "confirmPass" && !value) {
      delete newFormDataValues.confirmPass;
    }
    setFormDataValues(newFormDataValues);
    formValues(newFormDataValues);
  };

  const handleSwitchTicketChange = (value) => {
    try {
      setLimitedTickets(value);
      ticketsValue(value);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSwitchInvitationChange = (value) => {
    try {
      setLimitedInvitations(value);
      invitationValue(value);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5">Informations</MDTypography>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Nom"
                name="firstName"
                value={formDataValues.firstName}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Prénom"
                name="lastName"
                value={formDataValues.lastName}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="CIN (Carte d'Identité Nationale)"
                name="cin"
                value={formDataValues.cin}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="type-label"
                  name="type"
                  value={formDataValues.type}
                  onChange={handleInputChange}
                >
                  <FormControlLabel value="societe" control={<Radio />} label="Société" />
                  <FormControlLabel value="association" control={<Radio />} label="Association" />
                  <FormControlLabel
                    value="autoentrepreneur"
                    control={<Radio />}
                    label="Autoentrepreneur"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {formDataValues.type == "societe" ? (
              <Grid item xs={12} sm={4}>
                <FormField
                  type="text"
                  label="Nom de la société"
                  name="companyName"
                  value={formDataValues.companyName}
                  onChange={handleInputChange}
                />
              </Grid>
            ) : formDataValues.type == "association" ? (
              <Grid item xs={12} sm={4}>
                <FormField
                  type="text"
                  label="Nom de l'association"
                  name="companyName"
                  value={formDataValues.companyName}
                  onChange={handleInputChange}
                />
              </Grid>
            ) : formDataValues.type == "autoentrepreneur" ? (
              <Grid item xs={12} sm={4}>
                <FormField
                  type="text"
                  label="Pseudo du producteur"
                  name="companyName"
                  value={formDataValues.companyName}
                  onChange={handleInputChange}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="ICE (Identifiant Commun d'Entreprise)"
                name="ice"
                value={formDataValues.ice}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="IF (Identifiant Fiscal)"
                name="if"
                value={formDataValues.if}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Compte bancaire"
                name="bankAccount"
                value={formDataValues.bankAccount}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Pseudo du producteur"
                name="pseudo"
                value={formDataValues.pseudo}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Email"
                name="email"
                value={formDataValues.email}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="password"
                label="Mot de passe"
                name="password"
                value={formDataValues.password}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormField
                type="password"
                label="Confirmer le mot de passe"
                name="confirmPass"
                value={formDataValues.confirmPass}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={1}>
                  <Switch
                    checked={limitedTickets}
                    onChange={() => handleSwitchTicketChange(!limitedTickets)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormField
                    type="number"
                    label="Nombre des tickets"
                    name="numberOfTickets"
                    value={formDataValues.numberOfTickets}
                    onChange={handleInputChange}
                    disabled={!limitedTickets}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <FormLabel id="isActive-label">Statut</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="isActive-label"
                      name="isActive"
                      value={formDataValues.isActive}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel value="true" control={<Radio />} label="Activée" />
                      <FormControlLabel value="false" control={<Radio />} label="Disactivée" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={1}>
                  <Switch
                    checked={limitedInvitations}
                    onChange={() => handleSwitchInvitationChange(!limitedInvitations)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormField
                    type="number"
                    label="Nombre des invitations"
                    name="numberOfInvitations"
                    value={formDataValues.numberOfInvitations}
                    onChange={handleInputChange}
                    disabled={!limitedInvitations}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>

        <Divider sx={{ my: 2 }} />
        <MDTypography variant="h5">Événements autorisés</MDTypography>
        <MDBox mt={1}>
          <Autocomplete
            multiple
            options={eventImgList}
            getOptionLabel={(option) =>
              `${option.eventTitle}${option.isCinema ? " 🎬" : option.isCirque ? " 🎪" : ""}`
            }
            value={eventImgList.filter((e) => selectedEvents.includes(String(e._id)))}
            onChange={(_, newValue) => {
              onSelectedEventsChange(newValue.map((e) => String(e._id)));
            }}
            isOptionEqualToValue={(option, value) => String(option._id) === String(value._id)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={`${option.eventTitle}${option.isCinema ? " 🎬" : option.isCirque ? " 🎪" : ""}`}
                  {...getTagProps({ index })}
                  key={option._id}
                />
              ))
            }
            renderInput={(params) => (
              <MDInput
                {...params}
                label="Sélectionner des événements"
                placeholder="Rechercher un événement..."
              />
            )}
          />
        </MDBox>
      </MDBox>
    </Card>
  );
}

FormFields.propTypes = {
  formValues: PropTypes.string.isRequired,
};

export default FormFields;
